<template>
  <div class="bitapp-download-wrap" v-show="isShowDownApp">
    <div class="bitapp-download-content">
      <div class="bit-box">
        <img class="bitm-img" src="./assets/img/bitm.png" />
        <div class="text-box">
          <p class="t1">{{ $t('download_app.a3') }}</p>
          <p>{{ $t('footer.slogan_1') }}</p>
        </div>
      </div>
      
      <!-- :href="https://bitmart.onelink.me/FmvA/euj83c7c?af_force_deeplink=true" -->
      <a
        v-if="isIOS"
        class="btn-box el-icon-download"
        @click="onDownload"
      >
      </a>
      <div v-else class="btn-box el-icon-download" @click="onDownload">
        <!-- {{$t('download_app.a5')}} -->
      </div>
      <!-- <span class="iconfont cl-btn" @click="doClose">&#xe60a;</span> -->
    </div>
  </div>
</template>

<script>
import { breakDownHostUrl } from '~/common/js/utils';
import { track } from '~/common/js/sensor';
import messages from './i18n';
import { usePatchStore } from '~~/common/js/patch';
export default {
  i18n: { messages },
  name: 'DownloadappCompo',
  computed: {
    locale() {
      return this.store?.locale;
    }
  },
  data() {
    return {
      isShowDownApp: false,
      newHost: null,
      isIO: false,
      isIOS: false,
    };
  },
  mounted() {
    const host = window.location.host;
    let url = breakDownHostUrl(host);
    this.newHost = url;
    if (window.location.href.indexOf('.io') >= 0) {
      this.isIO = true;
    }
    import('amfe-env').then((env) => {
      this.isIOS = env.os.isIOS;
      if (!env.os.isIOS && !env.os.isAndroid) {
        this.isShowDownApp = false;
        return;
      }

      if (window.navigator.userAgent.indexOf('BitMart') >= 0) {
        // 在 Bitmart APP里面
        this.isShowDownApp = false;
      } else {
        this.isShowDownApp = true;
      }
      // let downloadPicked = window.localStorage.getItem('downloadPicked')
      // if (!downloadPicked) {
      //   this.isShowDownApp = true
      // } else {
      //   this.isShowDownApp = false
      // }
    });
  },
  methods: {
    onDownload() {
      import('amfe-env').then((env) => {
        // 都先尝试打开
        // 有邀请码，就跳到注册页
        // 无邀请码就跳到默认首页

        // inviteCode的优先级取值
        // 1. url链接上的inviteType
        // 2. url链接上的r(即inviteCode)
        // 3. sessionStorage里缓存的inviteType
        // 4. cookie缓存里的inviteType
        // 5. sessionStorage里缓存的inviteCode
        // 6. cookie缓存里的inviteCode
        let inviteCode = this.$route.query.r;

        // 如果inviteCode还是为空的，则继续先从sessionStorage或cookieinviteType里去拿
        if (!inviteCode) {
          inviteCode = sessionStorage.getItem('inviteCode') || localStorage.getItem('inviteCode');
        }
        const schema = inviteCode ? 'bitmart://register?inviteCode=' + inviteCode : 'bitmart://app';
        if (env.os.isIOS || env.os.isAndroid) {
          try {
            window.location.href = schema;
          } catch (_e) {}
          track('ClickAppDownload', {
            download_type: env.os.isIOS ? 5 : 6,
          }).finally(() => {
            setTimeout(() => {
              if (env.os.isIOS) {
                // window.open ios 会被safari设置拦截
                window.location.href = `https://h5.bitmart.com/env/${this.locale}`;
                // 'https://itunes.apple.com/us/app/bitmart-crypto-exchange/id1396382871?mt=8'
              } else if (env.os.isAndroid) {
                window.open('https://play.google.com/store/apps/details?id=com.bitmart.bitmarket', '_blank');
              }
            }, 1000);
          });
        }
      });

      // 关闭弹窗
      this.isShowDownApp = false;
    },
  },
  setup() {
    const { store } = usePatchStore();
    return {
      store
    };
  }
};
</script>

<style lang="less">
@import '~/common/css/element-base-type.less';

.bitapp-download-wrap {
  // position: fixed;
  // z-index: 999;
  // top: 0;
  // left: 0;
  padding: 0 16px;
  height: 66px;
  width: 100%;
  background-color: @blue-base;
  box-sizing: border-box;
}
.bitapp-download-content {
  height: 66px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .bit-box {
    display: flex;
    align-items: center;
    .bitm-img {
      width: 45px;
      height: 45px;
      margin-right: 12px;
    }
    .text-box {
      font-size: 12px;
      color: #353535;
      p {
        line-height: 1.2;
        color: @new-black-1;
      }
      .t1 {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .btn-box {
    width: 32px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    border: 1.5px solid @new-black-2;
    border-radius: 20px;
    font-size: 18px;
  }
  .cl-btn {
    position: absolute;
    font-size: 14px;
    right: 1px;
    top: 3px;
    color: #bbb;
  }
}
</style>
